import { Badge } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import Fade from '@material-ui/core/Fade';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import AccountCircle from '@material-ui/icons/AccountCircle';
import AssignmentIcon from '@material-ui/icons/Assignment';
import DescriptionIcon from '@material-ui/icons/Description';
import BuildIcon from '@material-ui/icons/Build';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import HomeIcon from '@material-ui/icons/Home';
import NotificationsIcon from '@material-ui/icons/Notifications';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router';
import Logo from '../../assets/images/logo.png';
import { useNotification } from '../../context/NotificationContext';
import { getUser, logout } from '../../services/auth';
import useStyles from './style';

export default function Header({ hasMenuLinks = true }) {
  const classes = useStyles();
  const history = useHistory();
  const { amountNotifications, setFetchNotification } = useNotification();
  const [anchorEl, setAnchorEl] = useState();
  const [open, setOpen] = useState(false);
  const [placement, setPlacement] = useState();
  const [userData, setUser] = useState({ nome: '' });

  const handleClick = (newPlacement) => (event) => {
    setAnchorEl(event.currentTarget);
    setOpen((prev) => placement !== newPlacement || !prev);
    setPlacement(newPlacement);
  };

  const logoutlink = (e) => {
    e.preventDefault();
    const canRedirect = logout();
    if (canRedirect) {
      history.push('/app');
    }
  };

  // const permissions = getPermissions({ moduloId: 1344 });
  const { permissions } =
    hasMenuLinks && JSON.parse(sessionStorage.getItem('@Capittale-User-Permissions'));

  const { menuSuperiors } =
    hasMenuLinks && JSON.parse(sessionStorage.getItem('@Capitalle-Menu-Superiors'));

  const canChangePassword = hasMenuLinks && permissions.find((p) => p.permissaoId === 62005);

  useEffect(() => {
    const user = getUser();

    if (user) {
      setUser(user);
      if (user.obrigaRegistrarPonto && location.pathname !== '/app/alterar-senha') {
        history.push('/app/registrar-ponto/warn');
      }
    }
  }, []);

  const clearMenuOrder = () => {
    sessionStorage.setItem('@Capitalle-Current-Menu', 1)
  }

  return (
    <div className={classes.root}>
      {hasMenuLinks && (
        <Popper
          open={open}
          anchorEl={anchorEl}
          placement={placement}
          transition
          style={{ zIndex: 100 }}
        >
          {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={350}>
              <Paper
                className={classes.rootPopper}
                style={{ height: canChangePassword ? '90px' : '60px' }}
              >
                <Link to="/app/registrar-ponto" className={classes.typography}>
                  Registrar ponto
                </Link>
                <Divider />

                {canChangePassword && (
                  <>
                    <Link to="/app/alterar-senha" className={classes.typography}>
                      Alterar senha
                    </Link>
                    <Divider />
                  </>
                )}

                <Link
                  to="/your-route"
                  onClick={(e) => logoutlink(e)}
                  className={classes.typography}
                >
                  Sair
                </Link>
              </Paper>
            </Fade>
          )}
        </Popper>
      )}
      <img src={Logo} alt="logo" className={classes.image} />
      {hasMenuLinks && (
        <div className={classes.menu}>
          <div className={classes.item}>
            <Link onClick={() => clearMenuOrder()} to="/app/home" className={classes.linkHome}>
              <HomeIcon className={classes.icon} />
              Início
            </Link>
          </div>
          {menuSuperiors && menuSuperiors.map((menu) => (
            <div className={classes.item}>
                {menu.titulo == 'Notificações' ? (
                  <div 
                    onClick={() => setFetchNotification(true)} className={classes.linkHome}
                  >
                    <Badge badgeContent={amountNotifications} color="error">
                      <NotificationsIcon className={classes.icon} />
                    </Badge>
                    {menu.titulo}
                  </div>
                ) : (
                  <Link 
                    onClick={() => clearMenuOrder()} to={"/app/operacao-menu"}
                    className={classes.linkHome}
                  >
                    <BuildIcon className={classes.icon} />
                    {menu.titulo}
                  </Link>
                )}
            </div>
          ))}

           {/* Add the new Código de Ética menu item */}
          <div className={classes.item}>
            <Link to="/app/codigo-etica" className={classes.linkHome}>
              <DescriptionIcon className={classes.icon} />
              Código de Ética
            </Link>
          </div>
          {/* {permissions.find((p) => p.moduloId === 2160) && (
            <div className={classes.item}>
              <Link to="/app/operacao-antecipacao" className={classes.linkHome}>
                <BuildIcon className={classes.icon} />
                Operações
              </Link>
            </div>
          )}

          <div className={classes.item}>
            <Link to="/#" onClick={() => setFetchNotification(true)} className={classes.linkHome}>
              <Badge badgeContent={amountNotifications} color="error">
                <NotificationsIcon className={classes.icon} />
              </Badge>
              Notificações
            </Link>
          </div> */}
          <div className={classes.itemUser} onClick={handleClick('bottom-end')}>
            <AccountCircle className={classes.iconUser} />
            <div className={classes.name}>
              <span className={classes.linkName}>{userData?.nome.split(' ')[0]}</span>
              <ExpandMoreIcon className={classes.iconExpand} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
